export default __webpack_public_path__ + "static/media/connecti.0959b328.png";